import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';


const HeadquartersYearGoalTable = ({rows}) => {
  
  

  return (
    <TableContainer component={Paper}>
      <Table aria-label="headquarter year table">
        <TableHead>
          <TableRow>
            <TableCell>본부명</TableCell>
            <TableCell align="right">목표</TableCell>
            <TableCell align="right">실적</TableCell>
            <TableCell align="right">달성률</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {rows && rows.map((row) => (
            <TableRow
              key={row.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
              <Typography variant="subtitle2"component="div">{row?.dptNm}</Typography>
              </TableCell>
              <TableCell align="right">{row?.goal}</TableCell>
              <TableCell align="right">{row?.result}</TableCell>
              <TableCell align="right">{row?.achieveRate} %</TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="right">0</TableCell>
            <TableCell align="right">0</TableCell>
            <TableCell align="right">0 %</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default HeadquartersYearGoalTable